import { defineMessages } from '@jutro/locale';

export default defineMessages({
    expirationDate: {
        id: 'platform.paymentdetails.credit-card-auto-details.Expiration Date',
        defaultMessage: 'Expiration Date',
    }
});
